module.exports = __webpack_public_path__ + "img/logo.9ebc8848.png";